<template>
  <CardModule title="Dados Bancários" class="mt-6">
    <v-row>
      <v-col cols="12">
        <v-radio-group
          v-model="$pointOfSale.cadastro.dados_bancarios.tipo_de_conta"
          class="mt-0"
          hide-details
        >
          <template v-slot:label>
            <span>Tipo de conta:</span>
          </template>
          <v-radio
            value="CORRENTE"
            class="rounded-lg pa-2"
            style="border: 1px solid rgb(0 0 0 / 42%)"
            active-class="active-class"
          >
            <template v-slot:label>
              <div>
                Conta Corrente<br />
                <small></small>
              </div>
            </template>
          </v-radio>
          <v-radio
            value="POUPANCA"
            class="rounded-lg pa-2"
            style="border: 1px solid rgb(0 0 0 / 42%)"
            active-class="active-class"
          >
            <template v-slot:label>
              <div>
                Conta Poupança<br />
                <small></small>
              </div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <BaseTextField
          label="Nome do títular"
          placeholder="Insira o nome do títular"
          hide-details
          v-model="$pointOfSale.cadastro.dados_bancarios.nome_titular"
          :error-messages="
            $pointOfSale.cadastro.dados_bancarios.error.nome_titular
          "
          @input="$pointOfSale.cadastro.dados_bancarios.error.nome_titular = []"
        />
      </v-col>
      <v-col cols="12">
        <BaseAutocomplete
          label="Selecione o banco"
          placeholder="Selecione o banco"
          item-text="banco_nome"
          item-value="banco_codigo"
          hide-details
          :items="$config.bancos.result"
          :filter="search"
          :error-messages="$pointOfSale.cadastro.dados_bancarios.error.banco"
          @input="$pointOfSale.cadastro.dados_bancarios.error.banco = []"
          v-model="$pointOfSale.cadastro.dados_bancarios.banco"
        >
          <template v-slot:selection="{ item }">
            <div v-if="item ? (bancos = item) : null">
              {{ item.banco_codigo }} - {{ item.banco_nome }}
            </div>
          </template>
        </BaseAutocomplete>
      </v-col>
      <v-col cols="12">
        <BaseTextField
          label="Agência"
          placeholder="Insira a agência"
          hide-details
          v-mask="['###', '###-#', '###-##']"
          v-model="$pointOfSale.cadastro.dados_bancarios.agencia"
          :error-messages="$pointOfSale.cadastro.dados_bancarios.error.agencia"
          @input="$pointOfSale.cadastro.dados_bancarios.error.agencia = []"
        />
      </v-col>
      <v-col cols="12">
        <BaseTextField
          label="Número da conta"
          placeholder="Ex: 00001"
          hide-details
          v-mask="['###', '####', '#####', '######']"
          v-model="$pointOfSale.cadastro.dados_bancarios.numero_conta"
          :error-messages="
            $pointOfSale.cadastro.dados_bancarios.error.numero_conta
          "
          @input="$pointOfSale.cadastro.dados_bancarios.error.numero_conta = []"
        />
      </v-col>
      <v-col cols="12">
        <BaseTextField
          label="Dígito"
          placeholder="Ex: 1"
          hide-details
          v-mask="'#'"
          v-model="$pointOfSale.cadastro.dados_bancarios.digito"
          :error-messages="$pointOfSale.cadastro.dados_bancarios.error.digito"
          @input="$pointOfSale.cadastro.dados_bancarios.error.digito = []"
        />
      </v-col>
    </v-row>
  </CardModule>
</template>
<script>
import CardModule from "@/components/cards/CardModule.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import PDVmixins from "@/mixins/PDV.mixins.js";
export default {
  name: "BankData",
  mixins: [PDVmixins],
  components: {
    CardModule,
    BaseAutocomplete,
    BaseTextField,
  },
  methods: {
    replaceSpecialChars(str) {
      str = str.toLowerCase();
      str = str.replace(/[ÀÁÂÃÄÅ]/, "a");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "e");
      str = str.replace(/[èèêë]/, "e");
      str = str.replace(/[Ç]/, "c");
      str = str.replace(/[ç]/, "c");
      str = str
        .toString()
        .normalize("NFD")
        .replace(/[^a-zA-Zs]/g, "");
      str = str.replace(" ", "-");

      return str;
      // return str.replace(/[^a-z0-9]/gi,'-');
    },
    search(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.banco_nome.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
  },
};
</script>
<style scoped>
.active-class {
  background-color: #e6f7ff !important;
  border-color: #91d5ff !important;
  color: #1890ff !important;
}
</style>
